import styled from 'styled-components'

export const AvatarWrapper = styled.div``
